/** Tab navigation and chart helpers for Unified School Management Dashboard */

export const USM_TABS = [
  { id: "overview", label: "Overview" },
  { id: "mix", label: "Management Mix" },
  { id: "share", label: "Share %" },
  { id: "schools", label: "Schools" },
  { id: "enrolment", label: "Enrolment" },
  { id: "teachers", label: "Teachers" },
  { id: "ptr", label: "PTR & Adequacy" },
  { id: "drilldown", label: "Detail Drilldown" },
  { id: "bifurcation", label: "Bifurcation Table" },
  { id: "actions", label: "Risk & Actions" },
  { id: "quality", label: "Data Quality" },
];

export const donutGradient = (segments) => {
  let cursor = 0;
  const colors = { primary: "#2563eb", accent: "#14b8a6", secondary: "#ff8a1f" };
  const stops = segments.map((seg) => {
    const start = cursor;
    cursor += seg.pct;
    return `${colors[seg.color] || colors.primary} ${start}% ${cursor}%`;
  });
  return `conic-gradient(${stops.join(", ")})`;
};
